module.exports = __webpack_public_path__ + "img/CCLF_infographic-02.1e404972.png";